import { createFeatureSelector } from '@ngrx/store';
import {
  EditUserState,
  PolicyDocumentsState,
  SecurityGroupsState,
  SideNavState,
  UserSearchState,
} from '../models/user.models';
import { EditUserReducer } from './edit-user.reducer';
import { PolicyDocumentsReducer } from './policy-documents.reducer';
import { SecurityGroupsReducer } from './security-groups.reducer';
import { SideNavReducer } from './side-nav.reducer';
import { UserSearchReducer } from './user-search.reducer';

export const featureUserManagementName = 'UserManagement';

export interface DragonflyState {
  sideNav: SideNavState;
  userSearch: UserSearchState;
  editUser: EditUserState;
  policyDocuments: PolicyDocumentsState;
  securityGroups: SecurityGroupsState;
}

export const moduleUserManagementReducers = {
  sideNav: SideNavReducer,
  userSearch: UserSearchReducer,
  editUser: EditUserReducer,
  policyDocuments: PolicyDocumentsReducer,
  securityGroups: SecurityGroupsReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(featureUserManagementName);
